import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { theme } from '../../data';
import { fmtDateTime } from '../../utils';
import ValueBadges from '../../valueBadges';
import {
  Badges,
  DeckPos,
  DraftNote,
  Divider,
  MBtn,
  MNav,
  Magnet,
  Meta,
  MetaStrong,
  ModalCard,
  ModalShell,
  NoValuesNote,
  Overlay,
  Pen,
  QLbl,
  QText,
  Stars,
  StarHalf,
  StarsQuestion,
  StarWrap,
} from './styles';

const CardModal: React.FC = () => {
  const {
    modal,
    cards,
    closeModal,
    goPrevModal,
    goNextModal,
    openWorkboard,
    confirmDeleteCardFlow,
  } = useSpinradContext();

  const card = cards.find(c => c.id === modal.cardId);

  if (!card) {
    return <Overlay $open={false} />;
  }

  const th = theme(card.from);
  const draft = !card.finalized;
  const noteCount = card.notes.length;
  const multi = modal.deck.length > 1;

  return (
    <Overlay
      $open
      onClick={e => {
        if (e.target === e.currentTarget) closeModal();
      }}
    >
      <ModalShell>
        <MNav
          $side="prev"
          $avail={multi && modal.deckIdx > 0}
          onClick={e => {
            e.stopPropagation();
            goPrevModal();
          }}
        >
          ‹
        </MNav>
        <ModalCard $bg={th.color} $color={th.ink}>
          <Magnet $color={th.color} $accent={th.accent} />
          {multi && (
            <DeckPos $color={th.inkSoft}>
              Karte {modal.deckIdx + 1} von {modal.deck.length}
            </DeckPos>
          )}
          <QLbl $color={th.inkSoft}>Frage</QLbl>
          <QText>{card.q}</QText>
          {draft ? (
            <DraftNote $color={th.inkSoft}>
              Noch in Arbeit – {noteCount} Notiz{noteCount !== 1 ? 'en' : ''},
              noch nicht abgeschlossen.
            </DraftNote>
          ) : (
            <>
              <Stars $color="#B8860B">
                {[1, 2, 3, 4, 5].map(i => {
                  const n = card.rating || 0;
                  const full = n >= i;
                  const half = !full && n >= i - 0.5;
                  return (
                    <StarWrap key={i}>
                      ☆
                      {(full || half) && (
                        <StarHalf style={half ? undefined : { width: '100%' }}>
                          ★
                        </StarHalf>
                      )}
                    </StarWrap>
                  );
                })}
              </Stars>
              <StarsQuestion $color={th.inkSoft}>
                Wie leben wir das aktuell im Unternehmen?
              </StarsQuestion>
            </>
          )}
          <Badges>
            {card.values.length ? (
              <ValueBadges values={card.values} fontSize={15} />
            ) : (
              <NoValuesNote $color={th.inkSoft}>
                – noch keine Kernwerte –
              </NoValuesNote>
            )}
          </Badges>
          <Meta $color={th.inkSoft}>
            Gezogen aus <MetaStrong $color={th.accent}>{th.name}</MetaStrong> ·
            erstellt am {fmtDateTime(card.createdAt)}
          </Meta>
          <Divider>
            <MBtn
              type="button"
              $variant="wb"
              onClick={() => {
                closeModal();
                openWorkboard(card.id);
              }}
            >
              <Pen>✎</Pen> Workboard ansehen
            </MBtn>
            <MBtn
              type="button"
              $variant="del"
              onClick={() =>
                confirmDeleteCardFlow(card.id, () => closeModal(), false)
              }
            >
              Karte löschen
            </MBtn>
            <MBtn type="button" $variant="cls" onClick={closeModal}>
              Schließen
            </MBtn>
          </Divider>
        </ModalCard>
        <MNav
          $side="next"
          $avail={multi && modal.deckIdx < modal.deck.length - 1}
          onClick={e => {
            e.stopPropagation();
            goNextModal();
          }}
        >
          ›
        </MNav>
      </ModalShell>
    </Overlay>
  );
};

export default CardModal;
